module.exports = __webpack_public_path__ + "img/compliance.f1d8d23e.png";